export default __webpack_public_path__ + "static/media/flood.d48d549d.svg";